<template>
  <div
    class="filter-carousel"
    :class="{ 'filter-carousel-round-effect': ready }"
  >
    <swiper id="swiperBox" ref="mySwiper" :options="swiperOption">
      <swiper-slide
        v-for="(filter, key) in filterList"
        :key="key"
        class="swiper-slide"
      >
        <div class="filter-item">
          <v-btn
            class="filter-btn"
            :class="{ 'filter-btn--active': filterActive(filter.value) }"
            rounded
            outlined
            @click="filterClick(filter.value)"
          >
            {{ filter.text }}
          </v-btn>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'FilterCarrousel',
  props: {
    filterList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 8,
      },
      activeFilter: 0,
      ready: false,
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  created() {
    this.filterClick(0)
  },
  methods: {
    filterActive: function(value) {
      if (value === this.activeFilter) {
        return true
      } else {
        return false
      }
    },
    filterClick: function(value) {
      this.activeFilter = value
      this.$emit('getActiveFilter', this.activeFilter)
    },
  },
}
</script>

<style scoped lang="scss">
.filter-carousel {
  position: relative;
  z-index: 0;
  #swiperBox {
    padding: 0 4.8%;
  }
  .swiper-slide {
    width: auto;
  }
  .filter-btn {
    height: 36px !important;
    font-size: 16px;
    line-height: 22px;
    font-weight: bold;
    padding: 6px 10px;
    box-sizing: border-box;
    color: #222;
    border: none;
    background-color: #fff;
    &::before {
      background-color: transparent !important;
    }
    &--active {
      background-color: #1da7fc;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
